import request from '@/utils/request';


import axios from 'axios';
// 智能校对
export const do_ = (params) => {
  // 用 CancelToken + setTimeout 主动 abort：axios 的 timeout 在部分 WPS 引擎下对“挂死”
  // 请求不生效，且不会中止底层连接；多次校对后挂死连接会占满并发连接池，导致后续请求
  // 全部超时。到点主动 cancel，真正释放连接。
  const source = axios.CancelToken.source();
  const timer = setTimeout(() => source.cancel('请求超时(60000ms)'), 60000);
  const config = {
    method: 'post',  // 请求方式
    url: setingDefault.correctIP + '/do/do',  // 请求 URL（走 seting 配置，便于切换环境）
    timeout: 60000,  // 兜底超时
    cancelToken: source.token,  // 到点主动中止，释放连接
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',  // 请求头 Content-Type
    },
    params: params,  // 使用 qs.stringify() 转换参数为查询字符串
  };
  // 发送请求并返回 Promise
  return axios(config)
    .then(response => {
      clearTimeout(timer);
      return response.data;  // 返回服务器响应的数据
    })
    .catch(error => {
      clearTimeout(timer);
      console.error('请求错误:', error);
      throw error;  // 抛出错误以便调用时处理
    });
};

// 一致性检查
export const consistencyCheck = (params) => request({
  url: '/do',
  method: 'get',
  customIP: setingDefault.consistencyCheckIP,
  params,
});

// 正词列表
export const getThesaurus = (params) => request({
  url: '/shuyutong/getDict_rightWordsByToken',
  customIP: setingDefault.dicIP,
  method: 'get',
  params,
});

// 正词删除
export const deleteThesaurus = (params) => request({
  url: '/shuyutong/deleteDict_rightWordsByToken',
  customIP: setingDefault.dicIP,
  method: 'get',
  params,
});

// 正词添加
export const addThesaurus = (params) => request({
  url: '/shuyutong/uploadDict_rightWordsByToken',
  customIP: setingDefault.dicIP,
  method: 'get',
  params,
});

// 正词修改
export const modifyThesaurus = (params) => request({
  url: '/shuyutong/modifyDict_rightWordsByToken',
  customIP: setingDefault.dicIP,
  method: 'get',
  params,
});

// ---------- 错词 ------------------

// 列表
export const getWrongThesaurus = (params) => request({
  url: '/shuyutong/getDict_wrongWordsByToken',
  customIP: setingDefault.dicIP,
  method: 'get',
  params,
});

// 删除
export const deleteWrongThesaurus = (params) => request({
  url: '/shuyutong/deleteDict_wrongWordsByToken',
  customIP: setingDefault.dicIP,
  method: 'get',
  params,
});

// 添加
export const addWrongThesaurus = (params) => request({
  url: '/shuyutong/uploadDict_wrongWordsByToken',
  customIP: setingDefault.dicIP,
  method: 'get',
  params,
});

// 修改
export const modifyWrongThesaurus = (params) => request({
  url: '/shuyutong/modifyDict_wrongWordsByToken',
  customIP: setingDefault.dicIP,
  method: 'get',
  params,
});

// ---------- 重点监控 ------------------
// 列表
export const getMonitor = (params) => request({
  url: '/shuyutong/getDict_specialWordsByToken',
  customIP: setingDefault.dicIP,
  method: 'get',
  params,
});

// 删除
export const deleteMonitor = (params) => request({
  url: '/shuyutong/deleteDict_specialWordsByToken',
  customIP: setingDefault.dicIP,
  method: 'get',
  params,
});

// 添加
export const addMonitor = (params) => request({
  url: '/shuyutong/uploadDict_specialWordsByToken',
  customIP: setingDefault.dicIP,
  method: 'get',
  params,
});

// 修改
export const modifyMonitor = (params) => request({
  url: '/shuyutong/modifyDict_specialWordsByToken',
  customIP: setingDefault.dicIP,
  method: 'get',
  params,
});

// 辞书查询
export const getDockingDictionaries = (params) => request({
  url: '/shuyutong/dockingDictionaries',
  customIP: setingDefault.dicIP,
  method: 'post',
  params,
});

